import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { useRegenerateModuleTokensMutation } from '~/types/types'
import { usePortfolioInviteModules } from '~/functions/usePortfolioInviteModules'


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCompanyToPortfolioCard',
  emits: ["company-created"],
  setup(__props, { emit }: { emit: ({
  (e: 'company-created'): void
}), expose: any, slots: any, attrs: any }) {



const {
  refetchAccount,
  Module,
  addEsgToken,
  addImpactGoalsToken,
  addImpactStrategyToken,
  addMetricsToken,
  addCompanyInfo,
  checkIsDisabled,
  hasAtLeastOneModule,
  selectedModules,
  shareLink,
  copied,
  copyShareLink,
  account,
} = usePortfolioInviteModules()

const onCompanyCreated = () => {
  refetchAccount()
  emit('company-created')
}

const onSetupDone = () => {
  emit('company-created')
}

const { mutate, onDone } = useRegenerateModuleTokensMutation()

const triggerNewLink = (dialog: { value: boolean }) => {
  mutate({ id: account.value?.id })
  dialog.value = false
}

onDone(() => {
  window.$nuxt.$emit('userMsg')
})

const activeTab = ref(0)

function onCopyLink() {
  copyShareLink((msg) => {
    window.$nuxt.$emit('userMsg', { type: 'error', msg })
  })
}

return { __sfc: true,emit, refetchAccount, Module, addEsgToken, addImpactGoalsToken, addImpactStrategyToken, addMetricsToken, addCompanyInfo, checkIsDisabled, hasAtLeastOneModule, selectedModules, shareLink, copied, copyShareLink, account, onCompanyCreated, onSetupDone, mutate, onDone, triggerNewLink, activeTab, onCopyLink }
}

})